import type { ReactNode, SyntheticEvent } from 'react';

import { useCopy } from '../lib/use-copy';
import { CopyIcon, MoreIcon } from './icons';
import { Menu, MenuContent, MenuItem, MenuTrigger } from './menu';

const quiet = (event: SyntheticEvent) => event.stopPropagation();

/** A table cell whose own clicks never reach the row (which opens it) nor start a drag. */
export const InertCell = ({ children }: { children: ReactNode }) => (
  <span
    className="flex items-center justify-center"
    onClick={quiet}
    onKeyDown={quiet}
    onPointerDown={quiet}
  >
    {children}
  </span>
);

export const RowMenu = ({ label, children }: { label: string; children: ReactNode }) => (
  <InertCell>
    <Menu>
      <MenuTrigger asChild>
        <button
          type="button"
          aria-label={`${label}: more`}
          className="flex size-control-xs items-center justify-center rounded-item text-muted hover:bg-ghost hover:text-primary"
        >
          <MoreIcon />
        </button>
      </MenuTrigger>
      <MenuContent align="end">{children}</MenuContent>
    </Menu>
  </InertCell>
);

// Stays open on select: there is no toast, so "Copied" in place is the only confirmation.
export const CopyMenuItem = ({ value, children }: { value: string; children: ReactNode }) => {
  const { copied, copy } = useCopy();
  return (
    <MenuItem
      onSelect={(event) => {
        event.preventDefault();
        void copy(value);
      }}
    >
      <CopyIcon />
      {copied ? 'Copied' : children}
    </MenuItem>
  );
};
